<template>
  <v-snackbar
    :model-value="isVisible"
    :color="color"
    rounded="lg"
    class="mb-5 opacity-90 app-toast"
    :z-index="10000"
    :max-width="width != null ? width : null"
    :min-width="width != null ? width : null"
    :style="style"
    :role="color == 'error' ? 'alert' : 'status'"
    :aria-live="color == 'error' ? 'assertive' : 'polite'"
    @update:model-value="emit('close')"
  >
    <v-icon
      size="20"
      :icon="icon"
      :class="iconSpin ? 'spin' : ''"
    />
    <span class="ml-2">{{ text }}</span>
    <template #actions>
      <v-btn
        density="compact"
        variant="plain"
        icon="mdi-close-circle"
        aria-label="Dismiss message"
        @click.stop="() => {
          emit('close')
        }"
      />
    </template>
  </v-snackbar>
</template>
<script setup>
const emit = defineEmits(['close'])

const props = defineProps({
  text: {
    type: String,
    default: null
  },
  color: {
    type: String,
    default: 'error'
  },
  icon: {
    type: String,
    default: 'mdi-alert-circle-outline'
  },
  iconSpin: {
    type: Boolean,
    default: false
  },
  timeout: {
    type: Number,
    default: 3000
  },
  width: {
    type: Number,
    default: null
  },
  style: {
    type: Object,
    default: null
  }
})

// eslint-disable-next-line no-undef
const { text, color, icon, iconSpin, timeout, width, style } = toRefs(props)

// eslint-disable-next-line no-undef
const isVisible = ref(true)
// eslint-disable-next-line no-undef
onMounted(async () => {
  setTimeout(() => {
    isVisible.value = false
    emit('close')
  }, timeout.value)
})
</script>

<style scoped>
  @keyframes spin {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  .spin {
    display: inline-block;
    animation: spin 1s linear infinite;
  }
</style>
